import { render, staticRenderFns } from "./ProblemStatusUpdate.vue?vue&type=template&id=3612f3ee&scoped=true"
import script from "./ProblemStatusUpdate.vue?vue&type=script&lang=js"
export * from "./ProblemStatusUpdate.vue?vue&type=script&lang=js"
import style0 from "./ProblemStatusUpdate.vue?vue&type=style&index=0&id=3612f3ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3612f3ee",
  null
  
)

export default component.exports